<icc-list searchable="true" [items]="modalTypes"  (select)="selectModalType($event)" [itemTemplate]="'itemColor'" [selected]="selectedModalTypeId"></icc-list>
